export default "__VITE_ASSET__Cej7tU19__"